import { Link } from "react-router-dom";
import Breadcrumbs from "../../styles/components/Breadcrumbs";
import "../../styles/pages/content/_administration.scss";

export default function AdministrationSupport() {
    return (
        <div className="adm-sub" id="administration-support">
            <div className="adm-sub__inner">
                <Breadcrumbs
                    items={[
                        { label: "Home", href: "/" },
                        { label: "Administration", href: "/administration" },
                        {
                            label: "Support workflows",
                            href: "/administration/support",
                        },
                    ]}
                />

                <div className="adm-sub__header">
                    <div>
                        <p className="adm-sub__eyebrow">Administration</p>
                        <h1 className="adm-sub__title">Support workflows</h1>
                        <p className="adm-sub__sub">
                            Coordinate internal escalations, tooling, and
                            enablement resources.
                        </p>
                    </div>
                </div>

                <section className="adm-sub__panel">
                    <h2>Overview</h2>
                    <p>
                        Streamline requests and share support playbooks with
                        your team.
                    </p>
                </section>
            </div>
        </div>
    );
}
